import React from 'react';
import TypingAnimation from '../../Common/typinganimation';

function Profile() {
  return (
    <section id="home" className="intro-profile md-mb50">
      <div className="row rest">
        <div className="col-lg-4 box-img main-bg">
          <div className="cont valign">
            <div className="full-width">
              <div className="img">
                <img src="/assets/imgs/header/profile.png" alt="" />
                <span className="icon">
                  <img src="/assets/imgs/header/icon1.png" alt="" />
                </span>
                <span className="icon">
                  <img src="/assets/imgs/header/icon2.png" alt="" />
                </span>
                <span className="icon">
                  <img src="/assets/imgs/header/icon4.png" alt="" />
                </span>
              </div>
              <div className="info text-center mt-30">
                <h5>Clarissa B. Vega</h5>
                <p className="fz-13 text-u">Software Developer</p>
              </div>
              <div className="social text-center mt-20">
                
                <a href="https://github.com/clangv">
                  <i className="fab fa-github"></i>
                </a>
                <a href="#0">
                  <i className="fab fa-linkedin-in"></i>
                </a>
                
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-8 content main-bg">
          <h1 className="whitespace-nowrap max-w-full overflow-hidden text-ellipsis">
          Hello, I’m <span className="inline-block whitespace-nowrap"><TypingAnimation /></span>, 
          <br />
            Exploring AI &{' '}
            <span className="bord">
            Blockchain Technologies,<i></i>
            </span>{' '}
            Based in Philippines.
          </h1>
          <div className="stauts mt-80">
            <div className="d-flex align-items-center">
              <div className="butn-presv">
                  <a href="/VegaClarissa-CV.pdf" className="butn butn-md butn-bord radius-5 skew">
                    <span>View C.V</span>
                  </a>
                  </div>
              <div className="ms-4">
                <div className="butn-presv">
                  <a href="/VegaClarissa-CV.pdf"
                  download
                  className="butn butn-md butn-bord radius-5 skew">
                    <span>Download C.V</span>
                  </a>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </section>
  );
}

export default Profile;
